import { AspectRatio, Image, AspectRatioProps } from "@chakra-ui/react";
import { publicUrl, v2FilesUrl } from "config";
import useCacheId from "hooks/useCacheId";
import { ImageSize } from "types";

type V2ImageProps = Omit<AspectRatioProps, "ratio"> & {
  tokenId?: number;
  size?: ImageSize;
  isDisabled?: boolean;
};

const V2Image = ({
  tokenId,
  size = "512",
  isDisabled = false,
  ...rest
}: V2ImageProps) => {
  const cacheId = useCacheId();

  return (
    <AspectRatio
      ratio={1}
      w="full"
      bg="dark.400"
      borderRadius="md"
      overflow="hidden"
      {...rest}
    >
      <Image
        src={
          tokenId !== undefined
            ? `${v2FilesUrl}/${
                size !== "full" ? `${size}/` : ""
              }${tokenId}.png${
                cacheId ? `?cacheId=${encodeURIComponent(cacheId)}` : ""
              }`
            : undefined
        }
        fallbackSrc={`${publicUrl}/v2-placeholder_transparent.png`}
        fit="cover"
        opacity={isDisabled ? 0.5 : 1}
        transition="opacity 0.15s"
      />
    </AspectRatio>
  );
};

export default V2Image;
